import { RespDoCheckIn } from '@models/micro/response/respDoCheckIn.model';

/**
 * Marca internamente una respuesta 200 OK que trae warning 3060 (PNR ACTIVITY
 * IN PROGRESS) como si fuera un error, para que participe del mismo retry()
 * que los errores HTTP reales dentro de ApiService.doCheckIn().
 *
 * No debe escapar fuera de doCheckIn(): se "deshace" en el catchError final,
 * devolviendo `response` tal cual por el canal de exito si se agotan los
 * reintentos.
 */
export class PnrActivityRetryableError extends Error {
  constructor(public readonly response: RespDoCheckIn) {
    super('PNR_ACTIVITY_IN_PROGRESS_WARNING');
  }
}
